<div class="bg-dark-50 w-full h-full flex justify-center items-center">
    <div class="bg-white rounded-xl p-8 shadow-lg flex flex-col gap-4 max-w-[600px]">
        <div class="w-full flex justify-center items-center">
            <img src="./assets/favicon.png" class="h-12" />
            <img src="./assets/logos/black.text.svg" class="h-10 ml-[-40px]" />
        </div>
        <div class="w-full border-b border-dark-200"></div>
        <div class="text-center flex flex-col gap-2">
            @if (error) {
                @switch (error) {
                    @case ('email_not_verified') {
                        <div class="font-bold text-3xl">Verify your email</div>
                        <p>Please click on the link we sent you to continue to myRTLS.</p>
                        <p>You may need to <b>check your spam</b> folder.</p>
                        <div></div>
                        <button mat-flat-button color="primary" (click)="continue()">Continue</button>
                        @if (supportEmail$ | async; as supportEmail) {
                            <p class="text-dark-400 text-sm">
                                Still can't find the email? <a class="cursor-pointer" (click)="logout()">Log out</a> and reset your password to
                                verify yourself or <a [href]="'mailto:' + supportEmail">contact us</a>.
                            </p>
                        } @else {
                            <p class="text-dark-400 text-sm">
                                Still can't find the email? <a class="cursor-pointer" (click)="logout()">Log out</a> and reset your password to
                                verify yourself.
                            </p>
                        }
                    }

                    @default {
                        <div class="font-bold text-3xl">Something went wrong</div>
                        <p>Please try to log out and then log in again.</p>
                        <div></div>
                        <button mat-flat-button color="primary" (click)="logout()">Log Out</button>
                        @if (supportEmail$ | async; as supportEmail) {
                            <p class="text-dark-400 text-sm">
                                If the issue persists feel free to <a [href]="'mailto:' + supportEmail">contact us</a>.
                            </p>
                        }
                    }
                }
            }
        </div>
    </div>
</div>
